import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import { sample } from "lodash";
import RootFractionInput, {
  parseRootFractionInput,
  formatLatexPreview,
} from "../../../../components/inputs/RootFractionInput";
import TrigValuesTable from "../../../../components/TrigValuesTable";


const VALUES = {
  sin: {
    0: "0",
    30: "\\dfrac{1}{2}",
    45: "\\dfrac{\\sqrt{2}}{2}",
    60: "\\dfrac{\\sqrt{3}}{2}",
    90: "1",
  },
  cos: {
    0: "1",
    30: "\\dfrac{\\sqrt{3}}{2}",
    45: "\\dfrac{\\sqrt{2}}{2}",
    60: "\\dfrac{1}{2}",
    90: "0",
  },
  tan: {
    0: "0",
    30: "\\dfrac{\\sqrt{3}}{3}",
    45: "1",
    60: "\\sqrt{3}",
    90: "nie istnieje",
  },
};

export function generateTask(options = {}) {
  const availableFunctions = VALUES[options.func]
    ? [options.func]
    : ["sin", "cos", "tan"];
  const availableAngles = options.acuteOnly
    ? [30, 45, 60]
    : [0, 30, 45, 60, 90];
  let func, angle, correct;
  do {
    func = sample(availableFunctions);
    angle = sample(availableAngles);
    correct = VALUES[func][angle];
  } while (correct === "nie istnieje");

  const task = {
    type: "TrigValueFromAngleTask",
    func,
    angle,
    expectedAnswer: correct,
  };

  return {
    ...task,
    data: task, // ⬅️ TO JEST KLUCZOWE
  };
}

export function renderTask({ func, angle }) {
  return (
    <p>
      Oblicz wartość funkcji:{" "}
      <InlineMath math={`\\${func}(${angle}^\\circ)`} />
    </p>
  );
}

export function renderInput({ func, angle }, userAnswer, onChange, disabled) {
  const label = `\\${func}(${angle}^\\circ)`;
  return (
    <RootFractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label={label}
    />
  );
}


export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "object" ? userAnswer.raw : userAnswer;
  const func = userAnswer?.func;
  const angle = userAnswer?.angle;

  if (!raw || typeof raw !== "string" || raw.trim() === "") {
    return <i>(brak odpowiedzi)</i>;
  }

  const label = func && angle ? `\\${func}(${angle}^\\circ)` : "";
  return (
    <InlineMath math={`\\displaystyle ${formatLatexPreview(raw, label)}`} />
  );
}



export function checkAnswer(task, userAnswer) {
  const { expectedAnswer, func, angle } = task;

  const normalize = (str) =>
    String(str)
      .replace(/\s/g, "")
      .replace(/\*/g, "")
      .replace(/sqrt\(([^)]+)\)/g, "√$1")
      .replace(/\\sqrt{([^}]+)}/g, "√$1")
      .replace(/\\dfrac{([^}]+)}{([^}]+)}/g, "$1/$2")
      .replace(/\\frac{([^}]+)}{([^}]+)}/g, "$1/$2")
      .replace(/[()]/g, "")
      .replace(/\\/g, "")
      .toLowerCase();

  const raw = typeof userAnswer === "object" ? userAnswer.raw : userAnswer;
  const parsed =
    typeof userAnswer === "object" && userAnswer.parsed != null
      ? userAnswer.parsed
      : parseRootFractionInput(raw);

  const expectedAsString = normalize(expectedAnswer);
  const parsedExpected = parseRootFractionInput(expectedAsString);

  const approxEqual =
    parsed != null &&
    parsedExpected != null &&
    Math.abs(parsed - parsedExpected) < 0.01;

  if (typeof userAnswer === "object") {
    userAnswer.func = func;
    userAnswer.angle = angle;
  }

  return {
    isCorrect: normalize(raw) === normalize(expectedAnswer) || approxEqual,
    comment:
      normalize(raw) === normalize(expectedAnswer) || approxEqual
        ? null
        : `Oczekiwano: ${expectedAnswer}`,
  };
}



export function renderAnswer({ func, angle, expectedAnswer }) {
  const latex = `\\${func}(${angle}^\\circ) = ${expectedAnswer}`;
  return (
    <div style={{ marginTop: "0.5rem" }}>
      <InlineMath math={latex} />
    </div>
  );
}

export function renderExplanation(input) {
  const data = input?.data ?? input;
  const { func, angle, expectedAnswer } = data;

  const funcLatex = `\\${func}(${angle}^\\circ)`;

  return (
    <div className="space-y-4">
      <div>
        <strong>Wyjaśnienie:</strong> Wartość odczytujemy z tabeli funkcji trygonometrycznych.
        <div className="my-2">
<BlockMath math={`${funcLatex} = ${expectedAnswer}`} />
        </div>
        <TrigValuesTable
          highlightFunc={func}
          highlightAngle={angle}
          highlightValue={expectedAnswer}
        />
      </div>
    </div>
  );
}
